const MenuIcon = ({icon, image}) => {
    if (!icon) return null;
    if (image) return <div className={`mdb-menu-icon ic ${icon}`} />;
    if (typeof icon === "string") return <i className={`mdb-menu-icon ${icon}`} />;

    const Icon = icon;
    return <Icon className="mdb-menu-icon" />;
};

export default MenuIcon;
